export default {
  home: "Home",
  search: "Search",
  catnav: "CatNav",
  pdp: "PDP",
  coupons: "Coupons",
  dynamicCMSListing: "DynamicCmsListing",
};
